import { render, staticRenderFns } from "./SanityMuxVideo.vue?vue&type=template&id=52784b54"
import script from "./SanityMuxVideo.vue?vue&type=script&lang=js"
export * from "./SanityMuxVideo.vue?vue&type=script&lang=js"
import style0 from "./SanityMuxVideo.vue?vue&type=style&index=0&id=52784b54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports